module.exports = __webpack_public_path__ + "assets/7acc44e6fec1835ba1f9ebd5cc7ddc8c.mp4";